<template>
  <svg
    width="148"
    height="111"
    viewBox="0 0 148 111"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2149 33.5775C29.4723 28.1748 57.5115 27.8361 63.3242 42.3563C69.1372 56.8765 115.824 47.7789 122.868 57.7557C129.912 67.7325 115.535 69.4632 133.042 78.3686C150.55 87.2739 138.863 104.148 136.642 104.148C134.42 104.148 15.1825 104.148 15.1825 104.148C15.1825 104.148 21.4437 88.2571 11.5426 73.9162C1.64153 59.5761 8.95743 38.9801 19.2149 33.5775Z"
      fill="#E7E8E9"
    />
    <path
      d="M73.1419 29.6689L48.3286 19.7502C46.9231 19.1884 45.3282 19.8723 44.7664 21.2779C44.2045 22.6834 44.8885 24.2783 46.294 24.8401L71.1073 34.7588C72.5128 35.3207 74.1077 34.6367 74.6695 33.2312C75.2314 31.8256 74.5474 30.2308 73.1419 29.6689Z"
      fill="#BBE2DA"
    />
    <path
      d="M116.362 18.3541L102.971 6.60408C101.834 5.60572 100.102 5.71871 99.1037 6.85646C98.1053 7.99421 98.2183 9.72587 99.3561 10.7242L112.747 22.4742C113.884 23.4726 115.616 23.3596 116.614 22.2218C117.613 21.0841 117.5 19.3524 116.362 18.3541Z"
      fill="#BBE2DA"
    />
    <path
      d="M76.1269 34.7715L101.802 12.0895C102.937 11.0873 103.044 9.35529 102.042 8.22088C101.039 7.08647 99.3075 6.97926 98.173 7.98142L72.4977 30.6635C71.3633 31.6656 71.2561 33.3977 72.2583 34.5321C73.2604 35.6665 74.9925 35.7737 76.1269 34.7715Z"
      fill="#BBE2DA"
    />
    <path
      d="M20.6099 50.4726L48.3009 23.9114C49.3933 22.8636 49.4294 21.1286 48.3816 20.0362C47.3338 18.9439 45.5988 18.9077 44.5064 19.9555L16.8155 46.5167C15.7231 47.5645 15.687 49.2995 16.7348 50.3919C17.7826 51.4842 19.5175 51.5204 20.6099 50.4726Z"
      fill="#BBE2DA"
    />
    <path
      d="M54.8148 45.2222H38.3704V104.148H54.8148V45.2222Z"
      fill="#76C6B5"
    />
    <path
      d="M40.4259 41.7964H52.7593L54.8148 45.2223H38.3704L40.4259 41.7964Z"
      fill="#97D3C6"
    />
    <path
      d="M82.2223 60.2964H65.7778V104.148H82.2223V60.2964Z"
      fill="#76C6B5"
    />
    <path
      d="M67.8334 56.8706H80.1667L82.2223 60.2965H65.7778L67.8334 56.8706Z"
      fill="#97D3C6"
    />
    <path d="M109.63 28.7778H93.1853V104.148H109.63V28.7778Z" fill="#76C6B5" />
    <path
      d="M95.2409 25.3521H107.574L109.63 28.778H93.1853L95.2409 25.3521Z"
      fill="#97D3C6"
    />
    <path
      d="M46.5926 26.7222C48.8631 26.7222 50.7037 24.8816 50.7037 22.6111C50.7037 20.3406 48.8631 18.5 46.5926 18.5C44.3221 18.5 42.4814 20.3406 42.4814 22.6111C42.4814 24.8816 44.3221 26.7222 46.5926 26.7222Z"
      fill="#76C6B5"
    />
    <path
      d="M74 36.315C76.2705 36.315 78.1111 34.4744 78.1111 32.2039C78.1111 29.9334 76.2705 28.0928 74 28.0928C71.7295 28.0928 69.8889 29.9334 69.8889 32.2039C69.8889 34.4744 71.7295 36.315 74 36.315Z"
      fill="#76C6B5"
    />
    <path
      d="M101.407 13.7037C103.678 13.7037 105.519 11.8631 105.519 9.59256C105.519 7.32205 103.678 5.48145 101.407 5.48145C99.137 5.48145 97.2964 7.32205 97.2964 9.59256C97.2964 11.8631 99.137 13.7037 101.407 13.7037Z"
      fill="#76C6B5"
    />
  </svg>
</template>
